import {
  PageContentContainer,
  PageLoading,
} from "@fp/ui/components/base/page-layout/page-layout";
import { AdminLayout } from "@/components/admin-layout";
import { AdminPageHeader } from "@/components/admin-page-header";
import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import axios from "@/lib/axios";
import type { FundingTransactionDto } from "@fp/admin-api-client";
import { FundingTransactionRow } from "@/components/funding/funding-transaction-row";

export const Route = createFileRoute("/funding/transactions")({
  component: RouteComponent,
  pendingComponent: () => <PageLoading />,
});

function RouteComponent() {
  const { data: transactions, isLoading } = useQuery({
    queryKey: ["fundingTransactions"],
    queryFn: async () => {
      const response = await axios.get<FundingTransactionDto[]>("/api/admin/funding/transactions");
      return response.data;
    },
  });

  if (isLoading) {
    return (
      <AdminLayout isWide>
        <AdminPageHeader
          title="Account Activity"
          parent={{ url: "/funding", label: "Funding" }}
        />
        <PageContentContainer>
          <PageLoading />
        </PageContentContainer>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout isWide>
      <AdminPageHeader
        title="Transaction History"
        parent={{ url: "/funding", label: "Funding" }}
      />
      <PageContentContainer>
        {transactions && transactions.length > 0 ? (
          <div className="bg-white border border-gray-200 rounded-lg divide-y divide-gray-200">
            {transactions.map((transaction) => (
              <FundingTransactionRow key={transaction.id} transaction={transaction} showTime />
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 py-8">No activity yet</div>
        )}
      </PageContentContainer>
    </AdminLayout>
  );
}